import Base from '../../_config/base';

class Newsanimation extends Base {
  constructor(el) {
    super(el);

    const heroTitle = el.querySelector('.hero__title');
    const cardTitle = el.querySelector('.newsGrid__card');

    if (heroTitle && heroTitle.classList.contains('hero__title_news')) {
      window.addEventListener('pageswap', async (e) => {
        if (e.viewTransition) {
          e.viewTransition.types.add('news-title-back');
        }
      });
      window.addEventListener('pagereveal', async (e) => {
        if (e.viewTransition) {
          e.viewTransition.types.add('news-title-forward');
        }
      });
    }

    if (cardTitle) {
      window.addEventListener('pageswap', async (e) => {
        if (e.viewTransition) {
          e.viewTransition.types.add('news-title-forward');
        }
      });
      window.addEventListener('pagereveal', async (e) => {
        if (e.viewTransition) {
          e.viewTransition.types.add('news-title-back');
        }
      });
    }
  }
}

Newsanimation.className = 'Newsanimation';
export default Newsanimation;
